export default {
    toast: {
        message: ''
    },
    giftBox:{
        id: 0,
        loyaltyCardListId: 0,
    },
    settingInfo: null,      // app 設定資料，從 api取得
    scanResult: '',         //相機掃描的結果
    changePageData: {       //觸發事件時用
        isChangePage :  false,
    },
    pageSnapshot:{},            //通用頁面快照
    cartStoreId:0,              //當前購物車store_id
    orderRecordPrepareCount:0,  //準備中訂單數量
    searchRecord:{              //關鍵字搜尋頁用
        maxLength: 5,           //最大數量
        lastKeyword: '',        //上次的搜尋
        keywordList: [],        //關鍵字列表
    },
    regPageSnapshot:{},         //註冊頁快照
    complexPageSnapshot: null,     //新搜尋頁快照
    publicCommDialogData: {     //公用CommDialog參數
        isShowDialog: false,
        outerContent: '',
        mainContent: '',
        isCancel: false,
        isConfirm: true,
        result: false,          //點擊確認或取消
        isResultEvent: false,   //是否執行確認或取消的事件
        icons: require('@/assets/images/dialog_question.svg'),
    },
    orderStoreInfo: {},    //點餐的店家相關資料
    shopAreaInfo: {        //商圈相關資料
        id: 0,
        officialName: "",
        name: "",
        logoPath: "",
    },
    cartPageSnapshot:{     //購物車頁面快照
        orderSettingTypeId: 0,  //使用的設定類型
        isLoading: false,
        orderSn: '',
        radioTake: '1',         //取餐方式
        showBank: false,        //更改付款方式
        paymentType: '',
        showModel: false,       //取消揪團時，被分享者要出現的提示
        completeModel: false,   //點餐成功彈框
        fareModel: false,       //外送費說明彈框
        payModel: false,        //付款說明彈框
        showDelDialog: false,   //刪除餐點彈框

        scrollHeight: '',
        scrollTop: '',
        storeId: 0,//店家id
        shoppingCartMealChoiceList: [], //購物車中的餐點資訊
        shoppingCartMealData: [],       //所有餐點資料
        refreshChoiceList: true,
        delMealIndex: null,     //暫存正在被刪除的餐點
        delMealOldVal:null,     //刪除前的數量
        delMealArr: [],         //紀錄被刪除的餐點
        originTotalPrice: 0,    //小計
        oldOriginTotalPrice: 0, //用優惠前小計
        sumAmount: 0,           //總餐點數量
        couponList: [],         //優惠表
        discountLimit: null,        //優惠限制設定
        concatCouponList: false,    //是否拼接優惠表
        couponChoiceList: [],       //已選擇的優惠券選項
        couponChoiceListItem: [],   //已選擇的優惠券
        calculatorCouponPrice: null,    //計算經過coupon的金額
        orderGift: [],      //可獲得票券
        taxIdNumber: '',    //統一編號
        remark: '',         //訂單備註

        storeInfo:{},
        userAddressData:{},
        userAddressId:0,
        userAddressParams: {},
        deliveryConditionList:[],//外送費資訊
        maxDistance:null,//最大運送距離
        isRequiredRemark:false,//訂單備註欄位是否必填
        isRequestTableware:false,//是否顯示需要拋棄式餐具、吸管嗎？
        isRequiredTableware:false,//是否需要拋棄式餐具、吸管
        remarkPrompt:'',//訂單備註欄位提示
        checkoutInstructions:'',//結帳說明
        isCanCoupon:false,//顯示優惠券使用欄位(開啟時，可提供顧客使用優惠券)
        isCanTaxIdNumber:false,//顯示統一編號輸入欄位(開啟時，可提供顧客輸入統編)
        mealPreparationTimeType:0,//餐點平均準備時間

        orderDeliveryList:[],//取餐方式（自取、外送、小短腿）
        completeOrderData: {
            "userName":   "",
            "radioTake":  0,
            "totalPrice": 0,
            "day":        "",
            "time":       "",
            "week":       "",
        },

        isCreditCard: false,//高鉅信用卡彈框
        takeoutId:0,//我想修改訂單回來帶入參數
        paymentMethod:{},
        orderTmpId: 0, //暫時訂單編號
        openUrl: '',
        routerGoEnable: 0,
        deliveryFee: 0,
        orderRewardPointInfo: { //點餐的紅利點數相關資料
            rewardPointList: [],
            rewardPointTakeoutList: [],
            rewardPointDeliveryList: [],
            rewardPointTableList: [],
            useRewardPointIdList: [],
            isLimitDiscountShare: false,
        },
        discountedPrice: 0, //優惠完的金額(優惠券、紅利點數) 不加外送費
    },
    notifyPageSnapshot: null,     //消息通知頁快照
    openPickTime: false,
    pickTimeData: {
        dateList: [],
        periodList: [],
    },
    qrCodePay:{         //掃描結帳功能
        storeId: 0,
        storeName: '',
        orderId: 0,
        paymentType: '1',
        originTotalPrice: 0,        //小計
        couponPrice: 0,             //折扣
        calculatorCouponPrice: 0,  //折扣後的金額
        isDiscount: false,          //顯示折扣
        couponChoiceListItem: [],   //已選擇的優惠券
    },
    clearCartData: {       //清除購物車用
        action: '',
        isClear:  false,
        orderSn: '',
    },
    offersData: {
        objectType: 0,
        objectId:  0,
    },
    shopAreaCartData: {       //商圈購物車用
        updateCartKey: 0,       //商圈購物車更新觸發key
        openCartDetailKey: 0,   //桌機版購物車明細開啟觸發key
    },
    isMainCloseBtn: false,
    lineAtWebPageData: {       //line@ 網頁用
        storeCode: '',
        filterStoreId: 0,       //只搜尋某間店的優惠券和點數用的
    },
    state: {
        selectCountryCode: ''
    },
    mutations: {
        setValueChange(state, payload) {
            state.selectCountryCode = payload;
        }
    },
    actions: {
        updateValueChange({ commit }, payload) {
            commit('setValueChange', payload);
        }
    },
    getters: {
        getValueChange: state => state.selectCountryCode
    },
    storeWebAction: {
        action: '',//每次都要改動，不用就空值，避免誤判
    },
}
